module.exports = __webpack_public_path__ + "static/media/slider2.fb441ff3.jpg";